const cashierConfig = typeof window === 'undefined' ? undefined : window.CASHIER_CONFIG;

const customizationSettings = cashierConfig?.customization_settings;

const sessionInformation = cashierConfig?.session_information;

const readBoolean = (value: boolean | undefined): boolean | null =>
  typeof value === 'boolean' ? value : null;

export const embeddedShowBackButton = readBoolean(customizationSettings?.show_back_button);

export const embeddedShowCloseButton = readBoolean(customizationSettings?.show_close_button);

export const embeddedHeaderStyle = customizationSettings?.header_style ?? null;

export const embeddedLayout = customizationSettings?.layout ?? null;

export const embeddedAppearance = customizationSettings?.appearance ?? null;

export const embeddedTransactionType = customizationSettings?.transaction_type ?? null;

export const embeddedPaymentTypeDisplay = customizationSettings?.payment_type_display ?? null;

export const embeddedBalanceDisplay = customizationSettings?.balance_display ?? null;

export const embeddedShowBalance = readBoolean(customizationSettings?.show_balance);

export const embeddedBrandColorsLight = customizationSettings?.brand_colors_light ?? null;

export const embeddedBrandColorsDark = customizationSettings?.brand_colors_dark ?? null;

export const embeddedFont = customizationSettings?.font ?? null;

export const embeddedButtonStyle = customizationSettings?.button_style ?? null;

export const embeddedPreselectFirstPaymentMethod = readBoolean(
  customizationSettings?.preselect_first_payment_method,
);

export const embeddedPreselectOnlyAvailableMethod = readBoolean(
  customizationSettings?.preselect_only_available_method,
);

export const embeddedBalance = sessionInformation?.balance ?? null;

export const embeddedCurrency = sessionInformation?.currency ?? null;

export const embeddedBaseCurrency =
  sessionInformation?.base_currency ?? sessionInformation?.currency ?? null;

export const embeddedLocale = sessionInformation?.locale ?? null;

/**
 * The ordered session intents list the host page boots with (primary intent
 * first), for the start-up header only. A missing, empty or non-list value
 * counts as absent (null), so the old `transaction_type` setting stays the
 * fallback for the start-up tab.
 */
export const embeddedIntents: string[] | null =
  Array.isArray(sessionInformation?.intents) && sessionInformation.intents.length > 0
    ? sessionInformation.intents
    : null;

export const embeddedSessionType = sessionInformation?.session_type ?? null;

export const embeddedTranslations = cashierConfig?.translations ?? null;
